import { render, staticRenderFns } from "./WeatherPromos.vue?vue&type=template&id=8aa45d4a&"
import script from "./WeatherPromos.vue?vue&type=script&lang=js&"
export * from "./WeatherPromos.vue?vue&type=script&lang=js&"
import style0 from "./WeatherPromos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WeatherPromos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports